import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineScheduleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 14a1 1 0 1 0 .0002-2A1 1 0 0 0 12 14Zm5 0a1 1 0 1 0 .0002-2A1 1 0 0 0 17 14Zm-5 4a1 1 0 1 0 .0002-2A1 1 0 0 0 12 18Zm5 0a1 1 0 1 0 .0002-2A1 1 0 0 0 17 18ZM7 14a.9998.9998 0 0 0 .7071-1.7071A.9998.9998 0 0 0 6 13a1 1 0 0 0 1 1ZM19 4h-1V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 16 3v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-9h16v9Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1ZM7 18a.9998.9998 0 0 0 .7071-1.7071A.9998.9998 0 0 0 6 17a1 1 0 0 0 1 1Z"/>
  </SvgIcon>
}

export default LineScheduleIcon
